<template>
  <div id="contenedor-main-listado-auditorias-informes">
    <template v-if="!$vuetify.breakpoint.xs">
      <desktop
        :solo-lectura="soloLectura"
        :listadoInformes="listadoInformes"
        >
      </desktop>
    </template>
    <template v-else>
     <!-- <mobile
          :listadoInformes="listadoInformes">
          </mobile> -->
     <desktop
        :solo-lectura="soloLectura"
        :listadoInformes="listadoInformes"
        >
      </desktop>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoAuditoriasInformes',
  props: {
    listadoInformes: {
      type: Array,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
};
</script>
